import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASEURL } from "../Config";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer";
import downloadIcon from "../assets/download_icon.png";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const SalesAttendanceReport = () => {
    const today = new Date();
    const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    firstOfMonth.setHours(0, 0, 0, 0);

    const formattedStartDate = firstOfMonth.getFullYear() + '-' 
    + String(firstOfMonth.getMonth() + 1).padStart(2, '0') + '-' 
    + String(firstOfMonth.getDate()).padStart(2, '0');

    const [attendanceData, setAttendanceData] = useState([]);
    const [managerNames, setManagerNames] = useState([]);
    const [summaryRow, setSummaryRow] = useState({});

    const [startDate, setStartDate] = useState(formattedStartDate);
    const [endDate, setEndDate] = useState(today.toISOString().split("T")[0]);

    useEffect(() => {
        fetchAttendanceData();
    }, [startDate, endDate]);

    const fetchAttendanceData = () => {
        axios.post(`${BASEURL}/api/v1/salesManagerAttendance/report`, {
            startDate: startDate,
            endDate: endDate
        })
            .then(res => {
                if (res.status === 200) {
                    const responseData = res.data;
                    setAttendanceData(responseData);

                    // Extract manager names dynamically from the first record
                    const managerKeys = Object.keys(responseData[0]).filter(
                        (key) => key !== "date"
                    );
                    setManagerNames(managerKeys);

                    // Calculate summary row
                    const summary = {};
                    managerKeys.forEach((manager) => {
                        const presentCount = responseData.filter(
                            (entry) => entry[manager] === "Present"
                        ).length;
                        summary[manager] = `${presentCount}/${responseData.length}`;
                    });
                    setSummaryRow(summary);
                }
            })
            .catch(err => {
                console.error("Error fetching attendance data:", err);
            });
    };

    const downloadExcel = () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Attendance Report");

        // Set the width for the columns
        worksheet.getColumn(1).width = 15; // First column (Date) to width 15
        managerNames.forEach((_, index) => {
            worksheet.getColumn(index + 2).width = 25; // Set all other columns to width 25 (starting from column 2)
        });

        // Add headers
        worksheet.addRow(["Date", ...managerNames]);
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).alignment = { horizontal: "center" };

        // Add attendance data
        attendanceData.forEach((entry) => {
            const row = worksheet.addRow([entry.date, ...managerNames.map((name) => entry[name])]);
            row.alignment = { horizontal: "center" };
        });

        // Add summary row
        const summaryRowData = ["Present/Total Days", ...managerNames.map((name) => summaryRow[name])];
        const lastRow = worksheet.addRow(summaryRowData);
        lastRow.font = { bold: true };
        lastRow.alignment = { horizontal: "center" };

        // Export workbook
        workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer]), `AttendanceReport-${startDate}-to-${endDate}.xlsx`);
        });
    };

    const handleStartDateChange = (e) => {
        const newStartDate = e.target.value;
        setStartDate(newStartDate);
    };

    const handleEndDateChange = (e) => {
        const newEndDate = e.target.value;
        setEndDate(newEndDate);
    };

    return (
        <div id="wrapper">
            <Sidebar act="salesReport" />
            <div className="content-page">
                <div className="content">
                    <Topbar act="Attendance Tracker" breadcrumbItems={['Sales App', 'Attendance Tracker']} />
                    <div className="container-fluid reports-container">
                        <div className="card sales-report-card">
                            <div className="card-body">
                                <div className="row">
                                    <div>
                                        <form>
                                            <div className="d-flex mt-2 align-items-center justify-content-between">
                                                {/* Date Picker */}
                                                <div className="d-flex">
                                                    <div className="d-flex align-items-center me-3">
                                                        <label htmlFor="startDate" className="date-label me-2">Start Date:</label>
                                                        <input
                                                            type="date"
                                                            id="startDate"
                                                            className="form-control date-picker"
                                                            value={startDate}
                                                            onChange={handleStartDateChange}
                                                            max={endDate}
                                                        />
                                                    </div>
                                                    <div className="d-flex align-items-center me-3">
                                                        <label htmlFor="endDate" className="date-label me-2">End Date:</label>
                                                        <input
                                                            type="date"
                                                            id="endDate"
                                                            className="form-control date-picker"
                                                            value={endDate}
                                                            onChange={handleEndDateChange}
                                                            max={today.toISOString().split("T")[0]}
                                                        />
                                                    </div>
                                                </div>
                                                {/* Icons Section */}
                                                <div className="d-flex align-items-center">
                                                    <button type="button" className="btn btn-icon btn-margin-right" onClick={downloadExcel}>
                                                        <img src={downloadIcon} alt="Download" className="icon-img" />
                                                    </button>
                                                    {/* <button type="button" className="btn btn-icon btn-margins">
                                                        <img src={sortIcon} alt="Sort" className="icon-img" />
                                                    </button>
                                                    <button type="button" className="btn btn-icon btn-margin-left">
                                                        <img src={filterIcon} alt="Filter" className="icon-img" />
                                                    </button> */}
                                                </div>
                                            </div>
                                        </form>
                                    </div>

                                    {/* {noResults ? <p>No results found</p> : ''} */}
                                    {/* end row */}
                                    <div className="reports-table-container">
                                        <table className="fixed-table">
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    {managerNames.map((name) => (
                                                        <th key={name}>{name}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {attendanceData.map((entry, index) => (
                                                    <tr key={index}>
                                                        <td>{entry.date}</td>
                                                        {managerNames.map((name) => (
                                                            <td key={name}><span className={entry[name] === "Present" ? "present attendance-status" : "absent attendance-status"}>{entry[name]}</span></td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td><b>Present/Total Days</b></td>
                                                    {managerNames.map((name) => (
                                                        <td key={name}><b>{summaryRow[name]}</b></td>
                                                    ))}
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default SalesAttendanceReport;
